import React, { useState, useEffect, createContext, useRef } from 'react'

export const HistoryContext = createContext()

export const HistoryProvider = (props) => {
	const { history, children } = props

	const [_historyRecord, setHistoryRecord] = useState([])
	const currentHistoryPos = useRef(-1)
	const keysRecord = useRef([])

	useEffect(() => {
		keysRecord.current = [history.location.key]
		setHistoryRecord([history.location.pathname])
		currentHistoryPos.current = 0
	}, [])

	useEffect(
		() =>
			history.listen((location, action) => {
				switch (action) {
					case 'POP': {
						currentHistoryPos.current = keysRecord.current.findIndex((key) => key === location.key)
						break
					}
					case 'PUSH': {
						currentHistoryPos.current = currentHistoryPos.current + 1
						keysRecord.current = [...keysRecord.current.slice(0, currentHistoryPos.current), location.key]
						setHistoryRecord((oldHistory) => [...oldHistory.slice(0, currentHistoryPos.current), location.pathname])
						break
					}
					case 'REPLACE': {
						setHistoryRecord((oldHistory) => [...oldHistory.slice(0, oldHistory.length - 1), location.pathname])
						keysRecord.current = [...keysRecord.current.slice(0, keysRecord.current.length - 1), location.key]
						break
					}
				}
			}),
		[]
	)

	const goBack = (fallBackPath = null) => {
		if (currentHistoryPos.current - 1 < 0) {
			if (typeof fallBackPath === 'string') {
				history.push(fallBackPath)
			} else {
				history.push('/')
			}
		} else {
			history.goBack()
		}
	}

	return (
		<HistoryContext.Provider
			value={{
				...history,
				goBack
			}}
		>
			{children}
		</HistoryContext.Provider>
	)
}
